<template>
  <div class="register">
    <div class="login-box">
      <router-link :to="this.$store.state.webCount.visitor_status == 0 ? '' : '/'">
        <img
          :src="this.$store.state.webCount.logo_wap"
          onerror="src='/static/images/login_logo.png'"
          class="logo"
        />
      </router-link>
    </div>
    <div class="login-cont">
      <div class="van-cell">
        <img src="./../../assets/img/iphone.svg" alt="" />
        <div class="van-cell__value">
          <input
            onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
            type="number"
            placeholder="请输入手机号"
            v-model="mobile"
            class="van-field__control"
          />
        </div>
      </div>

      <div class="codebox van-cell van-hairline van-field">
        <img src="./../../assets/img/login-code.svg" alt="" />
        <div class="van-cell__value">
          <input type="number" placeholder="短信验证码" v-model="code" class="van-field__control" />
        </div>
        <div class="van-field__button">
          <van-button
            slot="button"
            @click="getNvc()"
            class="get-code"
            :loading="codeLoading"
            >获取验证码</van-button
          >
        </div>
      </div>
      <div v-if="pwdType == false" class="van-cell">
        <img src="./../../assets/img/login-pwd.svg" alt="" />
        <div class="van-cell__value">
          <input
            type="password"
            placeholder="请输入密码（密码不少于6个字符）"
            v-model="password"
            class="van-field__control"
          />
        </div>
        <i @click="changeType()" class="van-icon iconfont icon-yanjing-bi inputlabel col-999"></i>
      </div>
      <div v-if="pwdType == true" class="van-cell">
        <img src="./../../assets/img/login-pwd.svg" alt="" />
        <div class="van-cell__value">
          <input
            type="text"
            placeholder="请输入密码（6-12位字符）"
            v-model="password"
            class="van-field__control"
          />
        </div>
        <i @click="changeType()" class="van-icon iconfont icon-ai-eye inputlabel col-999"></i>
      </div>
      <div v-if="pwdType1 == false" class="van-cell">
        <img src="./../../assets/img/login-pwd.svg" alt="" />
        <div class="van-cell__value">
          <input
            type="password"
            placeholder="再次确认密码"
            v-model="repassword"
            class="van-field__control"
          />
        </div>
        <i @click="changeType1()" class="van-icon iconfont icon-yanjing-bi inputlabel col-999"></i>
      </div>
      <div v-if="pwdType1 == true" class="van-cell">
        <img src="./../../assets/img/login-pwd.svg" alt="" />
        <div class="van-cell__value">
          <input
            type="text"
            placeholder="再次确认密码"
            v-model="repassword"
            class="van-field__control"
          />
        </div>
        <i @click="changeType1()" class="van-icon iconfont icon-ai-eye inputlabel col-999"></i>
      </div>
      <div>
        <van-button class="loginbtn" @click="senData()" :loading="loading">注册</van-button>
        <router-link to="/login" tag="div" class="text-cent">
          已有账号？
          <span class="ljdl">立即登录</span>
        </router-link>
      </div>
    </div>
    <Nvc 
      ref="nverify" 
      :verify="verifyMethods"
    ></Nvc>
  </div>
</template>

<script>
import Nvc from "../login/components/nvc";
export default {
  name: "index",
  components: {
    Nvc
  },
  data() {
    return {
      loading: false,
      codeLoading: false,
      mobile: "",
      code: "",
      //        name:'',
      password: "",
      repassword: "",
      No: "",
      pwdType: false, //此时文本框隐藏1，显示密码框1
      pwdType1: false, //此时文本框隐藏2，显示密码框2
      len: 0,
      dd: "",
      nvcType: 1
    };
  },
  watch: {
    password: function(newVal, oldVal) {
      this.password = this.password.replace(/\s+/g, "");
    },
    repassword: function(newVal, oldVal) {
      this.repassword = this.repassword.replace(/\s+/g, "");
    }
  },
  methods: {
    goLogin: function() {
      this.$router.push({ name: "NoteLogin" });
    },
    //密码的显示隐藏
    changeType: function() {
      this.pwdType = !this.pwdType; //跟着小眼睛变化，密码框隐藏显示文本框，内容就显示了
    },
    //密码的显示隐藏1
    changeType1: function() {
      this.pwdType1 = !this.pwdType1; //跟着小眼睛变化，密码框隐藏显示文本框，内容就显示了
    },
    getNvc: function() {
      // 进行人机验证
      const reg = /^[1][0-9][0-9]{9}$/;
      if (this.mobile == "") {
        this.$toast("请输入手机号");
        return;
      }
      if (!reg.test(this.mobile)) {
        this.$toast("请输入正确的手机号码");
        return;
      }
      this.nvcType = 1
      this.$refs.nverify.startVerify()
    },
    getCode: function(captchaVerifyParam) {
      return new Promise((resolve, reject) => {
        var mallid = localStorage.getItem("mallid");
        var _this = this;
        if (this.codeLoading == false) {
          this.codeLoading = true;
          this.$api.post(
            "message",
            { id_example: mallid, phone: this.mobile, type: 1, captchaVerifyParam },
            res => {
              if (res.data.code == "100") {
                this.No = res.data.data;
                resolve(true)
                this.$toast("发送成功请注意查收");
                var time = 60;
                _this.dd = setInterval(function() {
                  time--;
                  $(".register .codebox .van-button").html(time + " s");
                  if (time <= 0) {
                    clearInterval(_this.dd);
                    _this.codeLoading = false;
                    $(".register .codebox .van-button").html(
                      '<span class=\\"van-button__text\\">重新发送</span>'
                    );
                  }
                }, 1000);
              } else if (
                res.data.code == "400"
              ) {
                // this.$refs.nverify.verifyLater(res.data);
                resolve(false)
                _this.codeLoading = false;
              } else if (res.data.code == "800") {
                this.$toast("登录次数过多请稍后再试");
                resolve(true)
                _this.codeLoading = false;
              } else {
                this.$toast(res.data.message);
                resolve(true)
                _this.codeLoading = false;
              }
            }
          );
        }
      })
    },
    senData: function() {
      if (this.mobile == "") {
        this.$toast("请输入手机号");
        return;
      }
      var reg = /^[1][0-9][0-9]{9}$/;
      if (!reg.test(this.mobile)) {
        this.$toast("请输入正确的手机号码");
        return false;
      }
      var reg1 = new RegExp(/[^\x00-\xff]+$/);
      if (reg1.test(this.password)) {
        this.$toast("不能使用汉字或全角字符作为密码");
        return false;
      }
      this.getByteLen(this.password);
      if (this.len < 6) {
        this.$toast("密码不得少于6个字符！");
        return false;
      }
      this.nvcType = 2
      this.$refs.nverify.startVerify()
    },
    comit(captchaVerifyParam) {
      return new Promise((resolve, reject) => {
        var mallid = localStorage.getItem("mallid");
        var code = this.No + "_" + this.code;
        this.loading = true;
        this.$api.post(
          "user/register",
          {
            id_example: mallid,
            //            source:this.source,
            phone: this.mobile,
            password: this.password,
            repassword: this.repassword,
            verify: code,
            captchaVerifyParam
          },
          res => {

            if (res.data.code == "100") {
              resolve(true)
              this.$dialog
                .confirm({
                  title: "提示",
                  message: "注册成功是否立即登录？"
                })
                .then(() => {
                  this.$router.push({ path: "/login" });
                })
                .catch(() => {
                  // on cancel
                });
            } else if (
              res.data.code == "400"
            ) {
              resolve(false)
            } else {
              this.$toast(res.data.message);
              resolve(true)
            }
            this.loading = false;
          }
        );
      })
    },
    getByteLen: function(val) {
      //限制不少于6个字符
      var _this = this;
      for (var i = 0; i < val.length; i++) {
        var a = val.charAt(i);
        if (a.match(/[^\x00-\xff]/gi) != null) {
          _this.len += 2;
        } else {
          _this.len += 1;
        }
      }
      return _this.len;
    },
    verifyMethods(captchaVerifyParam) {
      return new Promise(async(resolve, reject) => {
        if(this.nvcType === 1) {
          const data = await this.getCode(captchaVerifyParam)
          resolve(data)
        } else if(this.nvcType === 2) {
          const data = await this.comit(captchaVerifyParam)
          resolve(data)
        }
      })
    }
  },
  mounted() {},
  destroyed: function() {
    clearInterval(this.dd);
    $(".register .codebox .van-button").html(
      '<span class=\\"van-button__text\\">获取验证码</span>'
    );
  }
};
</script>

<style lang="less" scoped>
.register {
  width: 100%;
  min-height: 100vh;
  background-image: url("./../../assets/img/login-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .login-box {
    text-align: center;
    padding-top: 0.6rem;

    .logo {
      width: auto;
      min-width: 1.84rem;
      max-width: 1.84rem;
    }
  }

  .login-cont {
    margin-top: 0.84rem;
    box-sizing: border-box;
    padding: 0 0.6rem;

    .van-cell {
      padding: 0.46rem 0;
      border-bottom: 0.01rem solid #dfdfdf;
      background: transparent !important;
      display: flex;
      align-items: center;

      &::after {
        border: none;
      }

      img {
        width: 0.48rem;
        height: 0.48rem;
      }

      .van-cell__value {
        padding-left: 0.2rem;

        .van-field__control {
          &::placeholder {
            color: rgba(38, 38, 38, 0.5);
          }
        }
      }
      .inputlabel {
        color: rgba(80, 80, 80, 0.6rem);
        font-size: 0.4rem;
      }

      .van-field__button {
        .get-code {
          min-width: 1.68rem;
          height: 0.52rem;
          background: #fe5c42;
          border-radius: 0.08rem;
          color: #fff;
        }

        .code {
          width: 1.68rem;
          height: 0.88rem;

          .s-canvas {
            width: 100%;
            height: 100%;
            #s-canvas {
              width: 1.68rem;
              height: 0.88rem;
            }
          }
        }
      }
    }

    .loginbtn {
      width: calc(100% - 0.6rem);
      height: 0.96rem;
      margin-left: 0.3rem;
      background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
      border-radius: 0.48rem;
      font-size: 0.3rem;
      font-weight: 500;
      color: #ffffff;
      line-height: 0.42rem;
      margin-top: 0.6rem;
    }

    .text-cent {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0.4rem;
      font-size: 0.28rem;
      font-weight: 400;
      color: rgba(38, 38, 38, 0.5);
      line-height: 0.48rem;

      .ljdl {
        font-size: 0.28rem;
        font-weight: 400;
        color: #025bff;
        line-height: 0.48rem;
      }
    }

    .login-text {
      margin-top: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .forgot-password {
        font-size: 0.28rem;
        font-weight: 400;
        color: rgba(38, 38, 38, 0.5);
        line-height: 0.48rem;
      }

      .restBox {
        width: 1.12rem;
        height: 0.4rem;
        font-size: 0.28rem;
        font-weight: 500;
        color: #025bff;
        line-height: 0.48rem;
      }
    }
  }

  .other-way {
    box-sizing: border-box;
    padding: 1rem 2rem 0 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .login_wx {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 0.88rem;
        height: 0.88rem;
      }

      span {
        margin-top: 0.2rem;
        font-size: 0.24rem;
        font-weight: 400;
        color: #929292;
        line-height: 0.42rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/register/index.vue